/** dataId 비교 시 문자열로 통일 (API 숫자/문자 혼용 대비) */
export function idKey(id) {
    return String(id);
}

/**
 * Shift 앵커({ sumDataId, dataId })가 가리키는 현재 목록의 행 인덱스.
 * sumDataId 우선, 없으면 dataId, 없으면 sumDataId 숫자 거리 최소, 그마저 없으면 0.
 */
export function resolveAnchorRowIndex(list, anchor) {
    if (!anchor || !Array.isArray(list) || list.length === 0) return null;

    const sum = anchor.sumDataId != null ? Number(anchor.sumDataId) : NaN;
    const did = anchor.dataId != null ? Number(anchor.dataId) : NaN;

    if (!Number.isNaN(sum)) {
        const idx = list.findIndex((r) => Number(r.sumDataId) === sum);
        if (idx >= 0) return idx;
    }
    if (!Number.isNaN(did)) {
        const idx = list.findIndex((r) => Number(r.dataId) === did);
        if (idx >= 0) return idx;
    }
    if (!Number.isNaN(sum)) {
        let best = 0;
        let bestDist = Infinity;
        list.forEach((r, i) => {
            const s = Number(r.sumDataId);
            if (Number.isNaN(s)) return;
            const d = Math.abs(s - sum);
            if (d < bestDist) {
                bestDist = d;
                best = i;
            }
        });
        if (bestDist !== Infinity) return best;
    }
    return 0;
}

/** 현재 목록 항목이 chkedData에 모두 포함됐는지 (전체 선택 상태) */
export function isFullListSelected(monitData, chkedData) {
    const allIdNos = (monitData ?? []).map((el) => el.dataId);

    if (allIdNos.length === 0 || !Array.isArray(chkedData) || chkedData.length === 0) {
        return false;
    }

    const selectedKeys = new Set(chkedData.map(idKey));

    return allIdNos.every((id) => selectedKeys.has(idKey(id)));
}
